import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../environment/environment";
import { getTokenCaptcha } from "./RecaptchaService";
const BASE_URL = `${environment.API}`;
//axios.defaults.headers.common.Authorization = `Bearer ${}`;

export const getOrdersByClient = createAsyncThunk(
  "ordersView/getOrdersByClient",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/Orders/getOrdersByClient/13`,
        {
          authorization: localStorage.getItem("userToken"),
          tokenCaptcha: await getTokenCaptcha("getOrdersByClient"),
        }
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getExpiringOrdersAgency = createAsyncThunk(
  "policiesExpiring/getExpiringOrdersAgency",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/Home/getPoliciesExpiring`,
        {
          authorization: localStorage.getItem("userToken"),
          tokenCaptcha: await getTokenCaptcha("getExpiringOrdersAgency"),
          draw: "1",
          columns: [
            {
              data: "policy_nbr",
              name: "",
              searchable: "true",
              orderable: "true",
              search: {
                value: "",
                regex: false,
              },
            },
            {
              data: "customer_name",
              name: "",
              searchable: "true",
              orderable: "true",
              search: {
                value: "",
                regex: false,
              },
            },
            {
              data: "expiration_date",
              name: "",
              searchable: "true",
              orderable: "true",
              search: {
                value: "",
                regex: false,
              },
            },
            {
              data: "policy_order",
              name: "",
              searchable: "false",
              orderable: "true",
              search: {
                value: "",
                regex: false,
              },
            },
          ],
          order: [
            {
              column: 4,
              dir: "asc",
            },
          ],
          start: "0",
          length: "25",
          search: {
            value: "",
            regex: false,
          },
          datatable: "true",
        }
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDataGraph = createAsyncThunk(
  "Home/getDataGraph",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("getDataGraph");
      const response = await axios.post(
        `${BASE_URL}/Home/getGraphData`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDataNews = createAsyncThunk(
  "Home/getDataNews",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("getDataNews");
      const response = await axios.post(`${BASE_URL}/Home/getNews`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getPoliciesByAgent = createAsyncThunk(
  "Home/getPoliciesByAgent",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("getPoliciesByAgent");
      const response = await axios.post(
        `${BASE_URL}/Orders/agentPolicies`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getQuotesByClient = createAsyncThunk(
  "ordersView/getQuotesByClient",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("getQuotesByClient");
      const response = await axios.post(
        `${BASE_URL}/Orders/getQuotesByClient`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteQuoteAPI = createAsyncThunk(
  "ordersView/deleteQuoteAPI",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("deleteQuoteAPI");
      const response = await axios.post(
        `${BASE_URL}/Orders/deleteQuote`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getActiveOrdersByClient = createAsyncThunk(
  "ordersView/getActiveOrdersByClient",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/Orders/activeOrders`, {
        authorization: localStorage.getItem("userToken"),
        tokenCaptcha: await getTokenCaptcha("getActiveOrdersByClient"),
      });
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getAgencyDataByClient = createAsyncThunk(
  "ordersView/getAgencyDataByClient",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/Orders/getAgencyData`, {
        authorization: localStorage.getItem("userToken"),
        tokenCaptcha: await getTokenCaptcha("getAgencyDataByClient"),
      });
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getCustomerByToken = createAsyncThunk(
  "ordersView/getCustomerByToken",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("getCustomerByToken");
      if (localStorage.getItem("kiosko") === "true") {
        params.kiosko = true;
      }
      const response = await axios.post(
        `${BASE_URL}/Customer/getCustomerByToken`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const issue = createAsyncThunk(
  "ordersView/issuePolicy",
  async (params, { rejectWithValue }) => {
    try {
      params.tokenCaptcha = await getTokenCaptcha("issuePolicy");
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/Orders/issuePolicy`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const checkQuote = createAsyncThunk(
  "ordersView/checkPolicyInfo",
  async (params, { rejectWithValue }) => {
    try {
      params.tokenCaptcha = await getTokenCaptcha("checkPolicyInfo");
      const response = await axios.post(
        `${BASE_URL}/Orders/checkPolicyInfo`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getRates = createAsyncThunk(
  "ordersView/getRates",
  async (params, { rejectWithValue }) => {
    try {
      params.tokenCaptcha = await getTokenCaptcha("getRates");
      const response = await axios.get(`${BASE_URL}/Orders/getRates?${params}`);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getRatesRedesign = createAsyncThunk(
  "ordersView/getRatesRedesign",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("getRatesRedesign");
      const response = await axios.post(`${BASE_URL}/Orders/getRates`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDocument = createAsyncThunk(
  "orders/getDocument",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("getDocument");
      const response = await axios.post(
        `${BASE_URL}/Orders/getDocumentPolicy`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const checkExistPolicyNumber = createAsyncThunk(
  "guest/checkExitsPolicyNumber",
  async (params, { rejectWithValue }) => {
    try {
      params.tokenCaptcha = await getTokenCaptcha("checkExitsPolicyNumber");
      const response = await axios.post(
        `${BASE_URL}/Orders/checkExitsPolicyNumber`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAppleTokenClient = createAsyncThunk(
  "orders/getAppleTokenClient",
  async (params, { rejectWithValue }) => {
    try {
      const tokenCaptcha = await getTokenCaptcha("getAppleTokenClient");
      const response = await axios.get(
        `${BASE_URL}/Orders/getAppleTokenClient`,
        { params: { tokenCaptcha } }
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getVenmoConfiguration = createAsyncThunk(
  "orders/getVenmoConfiguration",
  async (params, { rejectWithValue }) => {
    try {
      const tokenCaptcha = await getTokenCaptcha("getVenmoConfiguration");
      const response = await axios.get(`${BASE_URL}/Orders/getVenmoConfiguration`, {
        params: { tokenCaptcha },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Venmo is unavailable" });
    }
  }
);

export const print = createAsyncThunk(
  "orders/printQuote",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      params.tokenCaptcha = await getTokenCaptcha("printQuote");
      const response = await axios.post(
        `${BASE_URL}/Orders/printQuote`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
